import { Asset, AssetReplacements, UserLocationsFromSN } from "../resource/bff";
import { AssetWithState } from "../features/AssetList/AssetList";
import { LaptopReplacementStatesEnum } from "./constant";

export const buildHardwareReplacement = (
  assets: Asset[],
  replacements: AssetReplacements[]
) => {
  // filter out the replacements with state "Awaiting response from TW’er" or "Response Captured" or "Replacement In Progress"
  const filteredReplacements = replacements.filter(
    (item) =>
      item.state === LaptopReplacementStatesEnum.WAITING_RESPONSE ||
      item.state === LaptopReplacementStatesEnum.RESPONSE_CAPTURE ||
      item.state === LaptopReplacementStatesEnum.REPLACEMENT_IN_PROGRESS
  );
  const replacementsMap = new Map(
    filteredReplacements.map((replacement) => [
      replacement.serialNumber,
      replacement,
    ])
  );
  return assets.map((asset) => {
    const replacement = replacementsMap.get(asset.serialNumber);

    if (replacement) {
      return {
        ...asset,
        state: replacement.state,
        deliveryMode: replacement.deliveryMode,
        initiatedDate: replacement.initiatedDate,
        requestId: replacement.requestId,
        isAllCountryLocationShowed: replacement.isAllCountryLocationShowed,
        isBuybackPreferenceEnabled: replacement.isBuybackPreferenceEnabled,
        allowDeferReplacement: replacement.allowDeferReplacement,
        ...(replacement.replacementPeriod && {
          replacementPeriod: replacement.replacementPeriod,
        }),
        ...(replacement.buyBackLink && {
          buyBackLink: replacement.buyBackLink,
        }),
        ...(replacement.details && {
          details: { ...replacement.details },
        }),
      };
    }
    return asset;
  });
};

export const filterSameLocations = (userLocations: UserLocationsFromSN) => {
  const {
    allLocationsInHomeOfficeCountry,
    workLocationAddress,
    homeLocationAddress,
  } = userLocations;

  if (allLocationsInHomeOfficeCountry) {
    const postalCodesToExclude = new Set(
      [...workLocationAddress, ...homeLocationAddress].map(
        (loc) => loc.postalCode
      )
    );

    userLocations.allLocationsInHomeOfficeCountry =
      allLocationsInHomeOfficeCountry.filter(
        (loc) => !postalCodesToExclude.has(loc.postalCode)
      );
  }
  return userLocations;
};

export function formatDate(date: Date) {
  const deferDate = date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  return deferDate.replace(/ (\d{4})$/, ", $1");
}

export const truncateTitle = (title: string, maxLength: number = 32) => {
  if (title.includes("Home Address") && title.length > maxLength) {
    const lastBracketIndex = title.lastIndexOf("(");
    const mainText = title.slice(0, lastBracketIndex);
    const suffix = title.slice(lastBracketIndex);
    return `${mainText.slice(0, maxLength)}...${suffix}`;
  } else {
    return title;
  }
};
